import { Component, HostBinding, Input } from '@angular/core';
import { ChatbotService } from '../../services/chatbot.service';
import { ChatbotConversationBase } from './chatbot-conversation.mixin';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css', './chatbot-layout.css']
})
export class ChatbotComponent extends ChatbotConversationBase {

  @Input() dashboardWidget = false;

  @HostBinding('class.chatbot-dashboard-embedded')
  get isDashboardEmbedded(): boolean {
    return this.dashboardWidget;
  }

  open = false;
  fontSize = 14;
  showGuidebook = false;

  guideCommands = [
    'Ask questions about company data',
    'Ask for meeting schedules [example: "schedule a {meeting-type} meeting on {date} at {time}"]',
    'Get Company Secretary information',
    'Use quick-reply buttons when DigiBot asks a question',
    'Use suggestions to start a new task after completing one'
  ];

  constructor(private chatbotService: ChatbotService) {
    super();
  }

  protected getChatbotService(): ChatbotService {
    return this.chatbotService;
  }

  toggleChat(): void {
    this.open = !this.open;
  }

  increaseFontSize(): void {
    if (this.fontSize < 20) {
      this.fontSize += 2;
    }
  }

  decreaseFontSize(): void {
    if (this.fontSize > 10) {
      this.fontSize -= 2;
    }
  }

  toggleGuidebook(): void {
    this.showGuidebook = !this.showGuidebook;
  }
}
